var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBlueArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 14,
    viewBox: "0 0 34 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.182 7L26.438.256 24.825 1.87l3.989 3.99H.104V8.14h28.71l-3.99 3.99 1.614 1.613L33.182 7z",
    fill: "#1B264F"
  })));
}
export default __webpack_public_path__ + "media/images/blueArrow-a4384d4f.svg";
export { SvgBlueArrow as ReactComponent };